// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2VYbE","title":"Images90_title__3edQC","images":"Images90_images__37CUX"};